import {
  get,
  post
} from './request';


/**
 * 登录
 */
export const login = (data) => post('/api3/login/login', data);
// export const login = (code, uname) => post('/api3/login/wechatUserinfo?code=' + code + '&uname=' + uname+ '&source_type="wechat"'  );
//下载地址
export const appdown = (data) => get('/api3/appdown', data);
//获取微信签名
export const wxConfig = (data) => get('/api3/wechat/getshall', data);
//获取微信签名
export const readman = (data) => get('/api3/readman/index.html', data);

//获取用户信息
export const getUserInfo = (data) => get('/api3/user/info', data);
// 查询反馈
export const getFeedback = (data) => get('/api3/user/feedback', data);
// 提交反馈
export const addFeedback = (data) => post('/api3/user/addFeedback', data);
/**
 * 订单
 */
//获取订单信息
export const GetOrderInfo = (data) => get('/api3/orderDetail', data);

//检测优惠券
export const OrderCheckCode = (data) => get('/api3/checkCode', data);

//检测优惠券
export const OrderCheckIntergral = (data) => get('/api3/checkIntergral', data);

//提交订单
export const OrderSubmit = (data) => post('/api3/addOrder', data);

//微信下单支付
export const OrderUnifiedorder = (data) => get('/api3/wxpay/unifiedorder', data);
//提交订单
export const Quick = (data) => post('/api3/joinpay/quick', data);

export const OrderJoinpayorder = (data) => get('/api3/joinpay/native', data);
export const Getcourseitem = (data) => get('/api3/course/getcourseitem.html', data);

/**
 * 首页
 * */
export const getRootList = (data) => get('/api3/customindex', data);
/**
 * 课程评论列表
 **/
export const getCourseCommon = (data) => get('/api3/courseComment', data);
//课程评论点赞
export const commentlikes = (data) => get("api3/courseCommentLike", data);
//音视频单击次数统计
export const accessStatistical = (data) => get("/api3/studentdata/setSudentCode", data);
//插入,更新学习记录
export const updateRecord = (data) => post("/api3/StudyList/update", data);
/*
个人中心
*/
//获取个人中心信息
export const getMemberIndexDetails = (data) => get('/api3/userIndex', data);

//获取我的会员卡信息
export const getMemberVipDetails = (data) => get('/api3/myCard', data);

//获取积分列表
export const getMemberJifenList = (data) => get('/api3/integralList', data);

//获取我的提问列表
export const getMemberAskList = (data) => get('/api3/myAsk', data);

//获取我的回答列表
export const getMemberAnswerList = (data) => get('/api3/myAnswer', data);

//获取学习记录
export const getMemberStudyRecord = (data) => get('/api3/studyList/recordList', data);

//获取我的提问
export const getMemberAsk = (data) => get('/api3/myAsk', data);

//获取消息中心
export const getMemberMessage = (data) => get('/api3/user/message', data);

//获取验证码
export const getMemberSendcode = (data) => post('/api3/user/sendcode', data);
export const getSendsms = (data) => get('/api3/user/sendsms', data);

//绑定手机
export const getMemberChecksms = (data) => post('/api3/user/checksms', data);

//清除学习记录
export const MemberCleanStudy = (data) => get('/api3/studyList/cleanOverStudy', data);

//获取设置
export const GetMemberSeting = (data) => get('/api3/user/Linkour', data);

//清除学习记录
export const GetMemberQuestion = (data) => get('/api3/QuestionBank/userBankList', data);

//获取公告列表
export const GetMemberNoticeList = (data) => get('/api3/User/noticeList', data);

//获取公告详情
export const GetMemberNotice = (data) => get('/api3/User/Notice', data);

//已读
export const GetUserIsread = (data) => get('/api3/user/userIsread', data);

//签到
export const MemberSign = (data) => get('/api3/sign', data);

//完成课程
export const GetMemberFinshCourse = (data) => get('/api3/myFinishCourse', data);

//我的订单列表
export const GetMemberOrderList = (data) => get('/api3/myOrderList', data);

//我的订单详情
export const GetMemberOrderDetail = (data) => get('/api3/myOrderDetail', data);

//企业课程列表
export const GetMemberCompanyList = (data) => get('/api3/user/AgencyCourse', data);

//企业课程详情
export const GetMemberCompanyDetail = (data) => get('/api3/user/AgencyCourseDetail', data);

//获取事项
export const GetMatter = (data) => get('/api3/course/getMatter', data);
/*
    资讯
*/
//获取资讯分类
export const GetInfoCate = (data) => get('/api3/artCate', data);

//获取资讯列表
export const GetInfoList = (data) => get('/api3/artList', data);

//获取资讯列表
export const GetInfoDetails = (data) => get('/api3/artDetail', data);

/**
 * 分销
 */

//获取近况
export const getRebateIndex = (data) => get('/api3/rebate', data);

//获取数据
export const getRebateData = (data) => get('/api3/rebateData', data);

//获取数据
export const getRebateBindAlipay = (data) => post('/api3/bindAlipay', data);

//获取绑定信息
export const getRebateUserInfo = (data) => get('/api3/rebateUserInfo', data);

//接触支付宝绑定
export const RebateRelieveAlipay = (data) => post('/api3/relieveAlipay', data);

//接触支付宝绑定
export const RebateCashWithdraw = (data) => post('/api3/cashWithdraw', data);

//接触支付宝绑定
export const RebateLeveUser = (data) => get('/api3/levelUser', data);

//订单列表
export const RebateWithList = (data) => get('/api3/withList', data);

//获取分享订单
export const RebateOrederList = (data) => get('/api3/rebateOrder', data);

//获取分销员列表
export const RebateUserList = (data) => get('/api3/rebateUser', data);

//获取海报信息
export const GetPosterDetail = (data) => get('/api3/Poster/setPoster', data);

//选择海报
export const ChoosePosterDetail = (data) => get('/api3/Poster/choosePoster', data);

//已购买
export const GetRebateBuyList = (data) => get('/api3/myBuy', data);

//分销说明
export const getRebateDesc = (data) => get('/api3/rebateDesc', data);

/*
    题库
*/
//获取有题库关联的一级课程
export const getCourseQuestion = (data) => get('/api3/QuestionBankCategory/getCourseQuestion', data);

//获取题库分类详情
export const getCategoryInfo = (data) => post('/api3/QuestionBankCategory/getCategoryInfo', data);

//获取题库类型详情
export const getQuestionTypeInfo = (data) => post('/api3/QuestionBank/getQuestionTypeInfo', data);

//获取题库分类列表
export const getQuestionCategory = (data) => post('/api3/QuestionBankCategory/topCategoryList', data);

//获取题库二级分类
export const getQuestionSecondCategory = (data) => get('/api3/QuestionBankCategory/CategoryList', data);

//获取题库列表
export const getQuestionDetail = (data) => get('/api3/QuestionBank/SubjectIndex', data);

//获取题库类型+每个类型下的分类（树形结构）
export const getQuestionByCid = (data) => get('/api3/questionBank/getQuestionByCid', data);

//获取题目列表
export const getQuestionList = (data) => get('/api3/Question/index', data);

//获取题库信息
export const getQuestionScreen = (data) => get('/api3/question/getSubjectInfo', data);

//获取习题列表
export const getQuestionExercise = (data) => post('/api3/question/practicelist', data);

//清除做题记录
export const QuestionCleanRecord = (data) => post('/api3/Question/cleanRecord', data);

//试题收藏
export const QuestionCollect = (data) => post('/api3/QuestionCollect/collect', data);

//提交笔记
export const QuestionTakeNotes = (data) => post('/api3/QuestionNote/takeNotes', data);

//获取收藏分类
export const getQuestionsCollect = (data) => post('/api3/QuestionCollect/bankType', data);
//获取收藏列表
export const GetQuestionCollectList = (data) => post('/api3/QuestionCollect/index', data);
//根据bank_category, bank_type获取收藏试题列表
export const GetQuestionCollectTypeList = (data) => post('/api3/QuestionCollect/typeIndex', data);

//获取笔记列表
export const GetQuestionNoteList = (data) => get('/api3/QuestionNote/index', data);

//获取错题列表
export const GetQuestionErrorList = (data) => get('/api3/QuestionError/index', data);

//根据章节id获取错题
export const GetListBySid = (data) => get('/api3/QuestionError/getListBySid', data);

//删除笔记列表
export const QuestionDeleteNote = (data) => post('/api3/QuestionNote/deleteNote', data);

//提交答案
export const QuestionSubmit = (data) => post('/api3/Question/questionSubmit', data);

//删除错题
export const QuestionDeleteError = (data) => post('/api3/QuestionError/deleteError', data);

//考试交卷
export const QuestionTestScore = (data) => get('/api3/Question/scoreStatistics', data);

//获取题库设置
export const QuestionSetting = (data) => get('/api3/Question/questionSetting', data);

//设置题库设置
export const setQuestionSetting = (data) => get('/api3/Question/setQuestionSetting', data);

//根据科目id获取用户开课的课程
export const getUserCourse = (data) => get('/api3/QuestionBankCategory/getUserCourse', data);

/*
    问答/帖子
*/

// 帖子列表
export const getAsk = (data) => get('/api3/ask', data);
// 帖子详情
export const getAskDetail = (data) => get('/api3/askDetail', data);
// 帖子提交
export const getAskPut = (data) => post('/api3/askPut', data);
// 一级回复
export const getAskAnswersubmit = (data) => post('/api3/answerSubmit', data);
// 二级回复
export const getAskReplysubmit = (data) => post('/api3/replySubmit', data);
// 上传图片
export const getAskImage = (data) => post('/api3/askImage', data);
// 点赞/取消点赞
export const getAskLike = (data) => post('/api3/like', data);

/*
    课程
*/

// 课程详情
export const getCourseDetail = (data) => get('/api3/courseDetail', data);
export const getCourseChapter = (data) => get('/api3/courseChapter', data);
export const getCourseComment = (data) => get('/api3/courseComment', data);
// 课程评论
export const getCourseCommentadd = (data) => get('/api3/courseCommentAdd', data);
// 课程搜索
export const getCourseSearch = (data) => get('/api3/courseSearch', data);
// 课程1-3级分类
export const getCourseCate = (data) => get('/api3/courseCate', data);
// 课程分类列表
export const getCourseList = (data) => get('/api3/courseList', data);
//课程视频
export const studyList = (data) => get('/api3/studyList/detail', data);
// 讲师列表
export const getTeachers = (data) => get('/api3/getTeachers', data);

//获取套餐列表数据
export const getBundleList = (data) => get('/api3/package/List', data);
export const getBundleDetail = (data) => get('/api3/package/Detail', data);

//修改视频时长
export const updateVideo = (data) => post('/api3/video/updateVideo', data);
// 获取学习记录
export const getCourseRecordList = (data) => get('/api3/studyList/courseRecordList', data);
// 课件
export const getCourseWare = (data) => get('/api3/course/getCourseWare', data);
// 押题
export const getCourseYati = (data) => get('/api3/course/getCourseYati', data);
// 获取视频URL
export const getVideoUrl = (data) => get('/api3/course/getVideoUrl', data);

/*
    首页
*/
export const getIndex = (data) => get('/api3/customindex', data);
// 获取押题数量
export const getYatiCount = (data) => get('/api3/course/getYatiCount', data);

/*
    直播
*/

export const getLiveList = (data) => get('/api3/live', data);
export const getLiveCount = (data) => get('/api3/liveCount', data);
export const getLiveDetail = (data) => get('/api3/liveDetail', data);
export const getLiveRoom = (data) => get('/api3/liveRoom', data);
// 添加观看
export const getLiveWatch = (data) => get('/api3/liveWatch', data);
// 添加互动记录操作
export const getLiveInteraction = (data) => get('/api3/liveInteraction', data);


/**
 * 拼团
 */
//拼团详情
export const getGroupDetail = (data) => get('/api3/spell/SpellGroupItem', data);

//检测拼团状态
export const getGroupResult = (data) => get('/api3/spell/SpellTransaction', data);


// 云信
export const addMsg = (data) => post('/api3/nim/addMsg', data);



// WEBPACK FOOTER //
// ./src/api/api.js